import { InjectionToken } from '@angular/core';

export const AUTOLOGIN: InjectionToken<string> = new InjectionToken('AUTOLOGIN');
